import React, { useState } from 'react';
import VendorCountByCategory from './ChartList/VendorCountByCategory';
import { useVendorCountContext } from 'contexts/APVendorLibraryContext/VendorCountProvider';
import { useVendorSpendContext } from 'contexts/APVendorLibraryContext/VendorSpendProvider';
import TopVendorsModal from './TopVendorsModal';
import { KpiGridContainer, Wrapper } from './ChartsWrapper.styles';
import { useCategoryAndLevelContext } from 'contexts/APVendorLibraryContext/VendorCategoryLevelProvider';
import KpiList from './KpiList/KpiList';

const ChartsWrapper = () => {
	const [topVendorsModalData, setTopVendorsModalData] = useState(null);

	const {
		isLoading: isVendorCountLoading,
		chartData: vendorCountData,
	} = useVendorCountContext();

	const {
		isLoading: isVendorSpendLoading,
		chartData: vendorSpendData,
	} = useVendorSpendContext();

	const { categoryAndLevel, handleColumnClick } = useCategoryAndLevelContext();

	const showTopVendorsModal = index => {
		const param = {
			categoryName: index,
			categoryLevel: categoryAndLevel.level,
		};
		setTopVendorsModalData(param);
	};
	const hideTopVendorsModal = () => {
		setTopVendorsModalData(null);
	};

	return (
		<Wrapper>
			<KpiGridContainer>
				<KpiList
					vendorCountData={vendorCountData}
					vendorSpendData={vendorSpendData}
					isVendorCountLoading={isVendorCountLoading}
					isVendorSpendLoading={isVendorSpendLoading}
				/>
			</KpiGridContainer>
			<VendorCountByCategory
				key={'spend'}
				chartTitle={'Vendor Spend by Category'}
				chartheight={'27%'}
				isLoading={isVendorSpendLoading}
				chartData={vendorSpendData}
				handleColumnClick={handleColumnClick}
				yAxis={'Spend'}
				categoryAndLevel={categoryAndLevel}
				onTopVendorsClick={showTopVendorsModal}
			/>
			<VendorCountByCategory
				key={'count'}
				chartTitle={'Vendor Count by Category'}
				chartheight={'27%'}
				isLoading={isVendorCountLoading}
				chartData={vendorCountData}
				handleColumnClick={handleColumnClick}
				yAxis={'Vendor Count'}
				categoryAndLevel={categoryAndLevel}
			/>

			{topVendorsModalData && (
				<TopVendorsModal
					onClose={hideTopVendorsModal}
					topVendorsModalData={topVendorsModalData}
				/>
			)}
		</Wrapper>
	);
};

export default ChartsWrapper;
